import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { checklistData } from '../../data/checklistData';
import { useChecklist } from '../../context/ChecklistContext';

const ZoneCheck = () => {
    const { orderId, zoneName } = useParams();
    const { addZonePhotos } = useChecklist();
    const navigate = useNavigate();
    const [checkedItems, setCheckedItems] = useState({});
    const [photoCount, setPhotoCount] = useState(0);

    const getBaseZoneName = (zoneParam) => {
        return zoneParam.replace(/-\d+$/, ''); // Удаляет числовые суффиксы, например "bedroom-1" -> "bedroom"
    };

    const baseZoneName = getBaseZoneName(zoneName);
    const zoneData = checklistData[baseZoneName] || null;

    if (!zoneData || !zoneData.items || !zoneData.photos) {
        return <div style={styles.container}><h1>Зона не найдена</h1></div>;
    }

    const handleCheckboxChange = (index) => {
        setCheckedItems((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const handlePhotoCapture = () => {
        if (photoCount >= zoneData.photos.length) {
            alert('Все фото уже добавлены.');
            return;
        }

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.capture = 'environment';

        input.onchange = (event) => {
            const file = event.target.files[0];
            if (file) {
                setPhotoCount((prevCount) => prevCount + 1);
                addZonePhotos(zoneName, { file, description: zoneData.photos[photoCount] });
            }
        };

        input.click();
    };

    const handleSubmit = () => {
        if (Object.values(checkedItems).filter(Boolean).length < zoneData.items.length) {
            alert('Пожалуйста, отметьте все пункты перед завершением.');
            return;
        }

        if (photoCount < zoneData.photos.length) {
            alert(`Пожалуйста, добавьте все фото. Осталось сделать ${zoneData.photos.length - photoCount} фото.`);
            return;
        }

        navigate(`/checklist/${orderId}/select-zones`);
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Проверка зоны: {zoneData.title}</h1>

            <div style={styles.checklist}>
                {zoneData.items.map((item, index) => (
                    <label key={index} style={styles.checkItem}>
                        <input
                            type="checkbox"
                            checked={!!checkedItems[index]}
                            onChange={() => handleCheckboxChange(index)}
                        />
                        {item}
                    </label>
                ))}
            </div>

            <div style={styles.photoUpload}>
                <h2>Фотоотчёт:</h2>
                <p>{`Требуется фото: ${zoneData.photos[photoCount] || 'Все фото сделаны'}`}</p>
                {photoCount < zoneData.photos.length && (
                    <button style={styles.photoButton} onClick={handlePhotoCapture}>
                        Сделать фото
                    </button>
                )}
            </div>

            <button style={styles.submitButton} onClick={handleSubmit}>Завершить проверку зоны</button>
        </div>
    );
};

const styles = {
    container: { padding: '20px', maxWidth: '600px', margin: '0 auto', fontFamily: 'Arial, sans-serif' },
    heading: { fontSize: '24px', marginBottom: '20px', textAlign: 'center' },
    checklist: { display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px' },
    checkItem: { fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' },
    photoUpload: { marginTop: '20px', textAlign: 'center' },
    photoButton: {
        padding: '15px', borderRadius: '8px', border: 'none',
        fontSize: '18px', color: 'white', backgroundColor: '#6CC8D9',
        cursor: 'pointer', width: '100%', maxWidth: '300px',
    },
    submitButton: {
        width: '100%', padding: '15px', borderRadius: '8px', border: 'none',
        fontSize: '18px', color: 'white', backgroundColor: '#6CC8D9',
        cursor: 'pointer', marginTop: '20px',
    }
};

export default ZoneCheck;
